import { useEffect, useState } from 'react'
import ESign911 from './components/ESign911'
import ESignDisbursmentAgreement from './components/ESignDisbursmentAgreement'
import { apiURL } from '../../../utilities/URLs'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { account } from '../../../classes/Account'
import { refreshAccessToken } from '../../../utilities/extensions'
import ESign3911 from './components/ESign3911'
import ESignCover from './components/ESignCover'
import ESign6042C from './components/ESign6042C'

export default function ESignPage() {
  const { applicationId } = useParams()
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') ?? ''
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState(type ? type : '911')

  const tabs = [
    { key: '911', label: 'Form 911' },
    { key: 'dis_agree', label: 'Disbursement Agreement' }
  ]

  const handleCheckESignComplete = async () => {
    const completeResponse = await fetch(`${apiURL}/api/applications/${applicationId}/e-sign/check-complete/`, {
      method: 'GET',
      headers: {
        'Authorization': account.accessToken
      }
    })
    const completeData = await completeResponse.json()
    if (completeData.response.error) {
      if (completeData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleCheckESignComplete() : navigate('/', { state: { expired: true } })
      } else
        console.error(completeData.response.error)
    } else {
      if (completeData.response.isComplete)
        navigate(`/applications/${applicationId}/packet`)
    }
  }

  // Only run the 911 / disbursement completion check on the default onboarding flow.
  // Quarter-specific flows (3911, cover, 6042c) share this page via ?type= and must not
  // redirect to Download Packet just because onboarding docs were signed earlier.
  useEffect(() => {
    if (!type)
      handleCheckESignComplete()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='w-full h-full flex flex-col items-center p-6 overflow-hidden'>
      <div className='w-full flex-1 flex flex-col min-h-0 p-4'>
        <div className='mb-4 shrink-0 transition-colors duration-300'>
          <h1 className='text-3xl font-bold text-gray-900 dark:text-white text-center mb-2'>Electronic Signature</h1>
          <p className='text-gray-600 dark:text-slate-400 text-center text-sm'>Please tab through each document below and complete the e-signature for each form.</p>
        </div>
        <div className='w-full flex-1 flex flex-col min-h-0'>
          {!type && (
            <div className='w-full overflow-x-auto hide-scrollbar flex flex-nowrap md:flex-wrap justify-start md:justify-center border-b mb-4 gap-2 shrink-0'>
              {tabs.map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`flex-shrink-0 px-4 py-2 rounded-t whitespace-nowrap transition-colors ${activeTab === tab.key ? 'border-b-2 border-ertc-primary text-ertc-primary font-semibold' : 'text-gray-500 dark:text-slate-400 hover:text-ertc-primary dark:hover:text-ertc-primary'}`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          )}
          <div className='w-full flex-1 flex flex-col min-h-0'>
            {activeTab === '911' && <ESign911 handleCheckESignComplete={handleCheckESignComplete} />}
            {activeTab === '3911' && <ESign3911 />}
            {activeTab === 'cover' && <ESignCover />}
            {activeTab === '6042c' && <ESign6042C />}
            {activeTab === 'dis_agree' && <ESignDisbursmentAgreement handleCheckESignComplete={handleCheckESignComplete} />}
          </div>
        </div>
      </div>
    </div>
  )
}
